
// Keep the hidden variant-id <select> in sync with the option <select>s so the
// correct variant (price + SKU) is added to cart. Works with the product form.
document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('.product form');
  if (!form) return;
  var optionSelects = form.querySelectorAll('.vselect');
  var idSelect = form.querySelector('.variant-id-select');
  var priceEl = document.getElementById('price');
  if (!optionSelects.length || !idSelect) return;

  function chosenTitle() {
    return Array.prototype.map.call(optionSelects, function (s) { return s.value; }).join(' / ');
  }
  function sync() {
    var want = chosenTitle();
    Array.prototype.forEach.call(idSelect.options, function (opt) {
      if (opt.textContent.trim().indexOf(want) === 0) {
        idSelect.value = opt.value;
        if (priceEl) {
          var m = opt.textContent.split('—')[1];
          if (m) priceEl.textContent = m.trim();
        }
      }
    });
  }
  Array.prototype.forEach.call(optionSelects, function (s) { s.addEventListener('change', sync); });
  sync();
});

// Homepage "Choose your size" filter chips
document.addEventListener('DOMContentLoaded', function () {
  var wrap = document.getElementById('homeFilters');
  if (!wrap) return;
  var chips = wrap.querySelectorAll('.chip');
  var cards = document.querySelectorAll('#homeGrid .prod');
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      chips.forEach(function (x) { x.classList.remove('active'); });
      c.classList.add('active');
      var f = c.getAttribute('data-filter');
      cards.forEach(function (card) {
        var g = card.getAttribute('data-group');
        card.style.display = (f === 'all' || g === f) ? '' : 'none';
      });
    });
  });
});

/* ===== Promo: announcement bar + welcome pop-up ===== */
(function () {
  // announcement bar dismiss
  var bar = document.getElementById('promoBar');
  if (bar) {
    try { if (localStorage.getItem('bf_promobar_off')) bar.style.display = 'none'; } catch (e) {}
    var x = document.getElementById('promoBarX');
    if (x) x.addEventListener('click', function () { bar.style.display = 'none'; try { localStorage.setItem('bf_promobar_off', '1'); } catch (e) {} });
  }

  // welcome pop-up
  var ov = document.getElementById('promoOverlay');
  if (!ov) return;
  var seen = false;
  try { seen = !!localStorage.getItem('bf_promopopup_seen'); } catch (e) {}
  if (seen) return;

  var code = ov.getAttribute('data-code') || 'WELCOME25';
  function close() { ov.classList.remove('show'); try { localStorage.setItem('bf_promopopup_seen', '1'); } catch (e) {} }
  setTimeout(function () { ov.classList.add('show'); }, 6000);

  var closeBtn = document.getElementById('promoClose');
  var no = document.getElementById('promoNoThanks');
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (no) no.addEventListener('click', close);
  ov.addEventListener('click', function (e) { if (e.target === ov) close(); });

  var form = document.getElementById('promoForm');
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (document.getElementById('promoEmail').value || '').trim();
    if (!email) return;
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '\u2713');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'newsletter, welcome25');
    var reveal = function () {
      document.getElementById('promoModalIn').style.display = 'none';
      document.getElementById('promoCodeBox').textContent = code;
      document.getElementById('promoSuccess').style.display = 'block';
      try { localStorage.setItem('bf_promopopup_seen', '1'); } catch (e) {}
    };
    fetch('/contact', { method: 'POST', body: fd }).then(reveal).catch(reveal);
  });
})();

/* ===== texture clip lightbox (click to enlarge) ===== */
(function () {
  var btn = document.getElementById('texClipBtn');
  var lb = document.getElementById('texLightbox');
  if (!btn || !lb) return;
  var vid = document.getElementById('texLightboxVid');
  var closeBtn = document.getElementById('texLightboxClose');
  function open() { lb.classList.add('show'); if (vid) { try { vid.currentTime = 0; vid.play(); } catch (e) {} } document.body.style.overflow = 'hidden'; }
  function close() { lb.classList.remove('show'); if (vid) { try { vid.pause(); } catch (e) {} } document.body.style.overflow = ''; }
  btn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
